import React from "react";
import { useNavigate } from "react-router-dom";
import {
  RankingFichaSetoresProvider,
  useRankingFichaSetores,
} from "./context/RankingFichaSetoresContext";
import { RankingFichaSetoresView } from "./components/RankingFichaSetoresView";

const RankingFichaSetoresContent: React.FC = () => {
  const navigate = useNavigate();
  const {
    lojasTv,
    geral,
    conferencia,
    producaoTotal,
    lojas,
    isLoading,
    selectedLojaId,
    showLojaSelector,
    dateLabel,
    selectedLojaNome,
    toggleLojaSelector,
    selectAllLojas,
    selectLoja,
  } = useRankingFichaSetores();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-red-900 text-white">
        <div className="text-center">
          <p className="text-xl">Carregando progresso dos setores...</p>
        </div>
      </div>
    );
  }

  return (
    <RankingFichaSetoresView
      lojasTv={lojasTv}
      geral={geral}
      conferencia={conferencia}
      producaoTotal={producaoTotal}
      lojas={lojas}
      selectedLojaId={selectedLojaId}
      showLojaSelector={showLojaSelector}
      dateLabel={dateLabel}
      selectedLojaNome={selectedLojaNome}
      onGoHome={() => navigate("/dashboard")}
      onToggleLojaSelector={toggleLojaSelector}
      onSelectAllLojas={selectAllLojas}
      onSelectLoja={selectLoja}
    />
  );
};

const RankingFichaSetoresPage: React.FC = () => {
  return (
    <RankingFichaSetoresProvider>
      <RankingFichaSetoresContent />
    </RankingFichaSetoresProvider>
  );
};

export default RankingFichaSetoresPage;
